import { IWebsiteAmenities } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemAmenities extends WebsiteBuilderItemBase {
    name = 'Amenities';
    navName = 'Amenities';
    navLink = 'amenities';
    isHomePagePart = true;
    isShowInMenu = false;

    amenitiesIds: number[] = [];

    set value(item: IWebsiteAmenities) {
        this.isPresent = item.status;
        this.priority = item.priority;
        this.amenitiesIds = item.amenitiesIds || [];
    }

    get value(): IWebsiteAmenities {
        return {
            amenitiesIds: this.amenitiesIds,
            priority: this.priority,
            status: this.isPresent
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-amenities.ts